import React from 'react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu'
import { useLanguage } from '../providers/LanguageContext'
import type { Language } from '../providers/LanguageContext'
import { Globe } from 'lucide-react'

const LANGUAGE_OPTIONS: { code: Language; label: string }[] = [
  { code: 'de', label: 'Deutsch' },
  { code: 'en', label: 'English' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'fr', label: 'Français (French)' },
  { code: 'es', label: 'Español (Spanish)' },
  { code: 'pt', label: 'Português (Portuguese)' },
  { code: 'zh', label: '中文 (Chinese)' },
  { code: 'tr', label: 'Türkçe (Turkish)' },
  { code: 'tlh', label: 'Klingon' },
  { code: 'ja', label: '日本語 (Japanese)' },
  { code: 'vi', label: 'Tiếng Việt (Vietnamese)' },
  { code: 'km', label: 'ខ្មែរ (Khmer)' },
]

const LanguageSwitcher: React.FC<{ compact?: boolean }> = ({ compact = false }) => {
  const { language, setLanguage } = useLanguage()

  const displayCode = language.toUpperCase().slice(0, 2)

  const triggerClass = compact
    ? 'flex items-center gap-1.5 h-8 px-2.5 rounded-md font-medium bg-muted border border-border hover:bg-accent transition-colors'
    : 'flex items-center space-x-2 px-3 py-2 rounded-lg font-medium bg-muted border border-border hover:bg-accent transition-all duration-200 hover:shadow-md'

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className={triggerClass}
          aria-label="Select language"
        >
          <Globe className={compact ? 'h-4 w-4 shrink-0' : 'h-4 w-4'} />
          <span className={compact ? 'text-xs font-medium' : undefined}>{displayCode}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LANGUAGE_OPTIONS.map(({ code, label }) => (
          <DropdownMenuItem
            key={code}
            onClick={() => setLanguage(code)}
            className={language === code ? 'font-bold bg-muted' : undefined}
          >
            {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default LanguageSwitcher
